import z from 'zod';
import { validateMobile } from '../index';

export const loginFormSchema = z.object({
  mobile: validateMobile,
});

export type LoginFormSchemaType = z.infer<typeof loginFormSchema>;
